import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ProductReportPage } from "@/features/reports/product-report-page";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	scope: z.string().optional(),
	available: z.boolean().optional(),
	/** Zakres sprzedazy i zakupow jako para dat "YYYY-MM-DD", oba konce wlacznie. */
	dateFrom: z.string().optional(),
	dateTo: z.string().optional(),
	/** Wyklucza apteke internetowa z kubla "wlasne". */
	noOnline: z.boolean().optional(),
	/** Id zapisanej listy BLOZ (`product_groups`) zawezajacej raport. */
	lista: z.coerce.number().int().positive().optional(),
	/** Nazwa listy — tylko do paska nad tabela, zeby po F5 nie bylo "lista #7". */
	listaNazwa: z.string().optional(),
	/** Ile kodow miala lista przy imporcie — do porownania z liczba wierszy. */
	listaKodow: z.coerce.number().int().nonnegative().optional(),
});

export type ProductReportSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/raport-produktowy")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.raport-produktowy",
			location.pathname,
		);
	},
	component: ProductReportPage,
	validateSearch: (search: Record<string, unknown>): ProductReportSearch =>
		searchSchema.parse(search),
});
